import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { getDevicesByBusinessId } from '../services/getDevicesByBusinessId.service';

export const loadDevicesBySelectedProjectBusinessId = createAsyncThunk(
  'devices/loadDevicesBySelectedProjectBusinessId',
  async (_, { getState, rejectWithValue }) => {
    const state = getState();

    const selectedProject = selectSelectedProject(state);
    const businessId = selectedProject?.business_id;

    if (!businessId) {
      return rejectWithValue('no business id');
    }

    const response = await getDevicesByBusinessId(businessId);
    return response;
  }
);
